import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalProps,
} from '@chakra-ui/react';
import { MODAL_OVERLAY_DARKNESS } from '../const';
import { CaravanFilterForm } from './CaravanFilterForm';
import { useTempFormSubmit } from './useTempFormSubmit';

type ModalPropsWithoutChildren = Omit<ModalProps, 'children'>;

export const SearchFormModal: React.FC<ModalPropsWithoutChildren> = (props) => {
  const { confirmSearch, formDisabled } = useTempFormSubmit();

  const handleSearch = () => {
    confirmSearch();
    props.onClose();
  };

  return (
    <Modal {...props}>
      <ModalOverlay bg={MODAL_OVERLAY_DARKNESS} />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <Flex gap={2} flexDir="column" pt={8}>
            <CaravanFilterForm />

            <Button
              variant="yellow"
              fontWeight="bold"
              borderRadius="20px"
              borderColor="gray.200"
              borderWidth="1px"
              mt={5}
              disabled={formDisabled}
              onClick={handleSearch}
            >
              Search
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
